import './map-set';
import { createRoot } from 'react-dom/client';
import './utils/request';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { JiraReporterLoader } from '@meitu/jira-reporter-loader';
import { Env, setConfig } from '@meitu/saas-editor-core/es/utils/upload-kit';
import { pushSessionRecentPage } from '@meitu/xdesign-widgets/dist/utils/sessionRecentPages';
import { CLIENT_LOCALE, initLocaleStore } from './i18n';
import Root from './root';
import SvgDesign from './router/design-svg';
import PosterEditor from './router/poster-editor';
import { isBetaEnv, isDevelopEnv, isPreEnv, isReleaseEnv } from './utils/env';

initLocaleStore(CLIENT_LOCALE);

window._stat_track = function () {};
const isDev = isDevelopEnv();
const basename = isDev ? '' : '/poster';

const render = () => {
    createRoot(document.getElementById('root')!).render(
        <Root>
            <BrowserRouter
                future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true,
                }}
                basename={basename}
            >
                <Routes>
                    {isDevelopEnv() || isPreEnv() ? (
                        <Route
                            path="/design-svg"
                            element={
                                <Suspense fallback={<></>}>
                                    <SvgDesign />
                                </Suspense>
                            }
                        ></Route>
                    ) : null}
                    <Route path="*" element={<PosterEditor />} />
                </Routes>
            </BrowserRouter>
            {!isReleaseEnv() && <JiraReporterLoader />}
        </Root>,
    );
};

const initApp = async () => {
    setConfig({
        app: 'xiuxiu-pro',
        // posters 文件夹
        type: 'designer',
        env: isReleaseEnv() || isBetaEnv() ? Env.Release : Env.Test, // 上传SDK的环境配置
    });
    pushSessionRecentPage();
    render();
};

document.addEventListener('DOMContentLoaded', () => initApp());
